
<section class="retailer-products-page">
  <!-- Breadcrumb / heading -->
  <div class="container fw-b d-flex justify-content-between align-items-center retailer-products-header">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems">
    </app-linker-route>

    <button
      type="button"
      class="btn btn6 primary-action-btn"
      id="asd"
      (click)="addProduct()">
      <i class="fa fa-plus" aria-hidden="true"></i>
      <span>Add Product</span>
    </button>
  </div>

  <!-- Main layout -->
  <div class="container wrapper-content retailer-products-shell">
    <div class="retailer-products-layout">
      <!-- Left: category / filters -->
      <aside class="left-container mt-4 mb-3 scrol">
        <h2 class="gg ml-3 list-cate">BROWSE CATEGORIES</h2>
        <div class="ex1">
          <div id="accordion">
            <menu-panel
              [categoryListArray]="categoryListArray"
              (onSubCategory)="getSubCategoryList($event)"
              (onSelectSubCategody)="getSubCateGoryData($event)">
            </menu-panel>
          </div>
        </div>
      </aside>

      <!-- Right: product cards -->
      <section class="right-container">
        <!-- Toolbar -->
        <div class="retailer-products-toolbar">
          <div class="toolbar-text-group">
            <p class="toolbar-eyebrow">Your Catalogue</p>
            <h2 class="toolbar-title">Retailer products</h2>
            <p class="toolbar-subtitle">
              Manage your active products, update listings, or add new items to your store.
            </p>
          </div>
          <div class="toolbar-meta">
            <span class="toolbar-chip">
              {{ totalItems || 0 }} product{{ (totalItems || 0) === 1 ? '' : 's' }}
            </span>
          </div>
        </div>

        <!-- Product grid -->
        <div class="products-grid" *ngIf="categoryListArrayNew?.length > 0">
          <div
            class="card-container"
            *ngFor="let item of categoryListArrayNew | paginate:{itemsPerPage:itemPerPage, currentPage: currentPage, totalItems: totalItems}; let j = last">
            <product-card
              [isImage]="true"
              width="100%"
              height="240px"
              [data]="item"
              (on_Click)="forID($event)"
              (on_Click_Edit)="forEdit($event)"
              [showEdit]="true">
            </product-card>
          </div>
        </div>

        <!-- Skeleton state -->
        <div class="products-grid skeleton-grid" *ngIf="!categoryListArrayNew?.length && !isLoading">
          <div
            class="card-container"
            *ngFor="let item of length(16)">
            <product-card
              [isImage]="false"
              width="100%"
              height="240px"
              [data]="item">
            </product-card>
          </div>
        </div>

        <!-- Empty / loading state -->
        <div class="products-empty-state" *ngIf="isLoading">
          <div class="empty-state-card">
            <i class="fa fa-cubes empty-icon" aria-hidden="true"></i>
            <h3>No products found</h3>
            <p>
              Start by adding a new product, or adjust your filters to see more of your catalogue.
            </p>
            <button
              type="button"
              class="btn btn6 ghost-secondary-btn"
              (click)="addProduct()">
              <i class="fa fa-plus" aria-hidden="true"></i>
              <span>Add first product</span>
            </button>
          </div>
        </div>
      </section>
    </div>

    <!-- Pagination -->
    <div class="custom-pagination mt-2 pagin22 retailer-pagination" *ngIf="totalItems > 20">
      <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
    </div>
  </div>
</section>
